export const environment = {
  production: false,
  farmer_base_url: 'https://api-development.kisan.io/api/farmers/',
  master_base_url: 'https://api-development.kisan.io/api/masters/',
  kisan_oauth_api_url:'https://api-development.kisan.io/api/farmers/auth/',
  kisan_oauth_client_id: 'd5f6da7b73a56d8e64bc6783ae3e1a1e',
  kisan_oauth_ui_url: 'https://farmer-auth-dev.kisan.in/authenticate',
  google_client_id : '558872860133-7j9gtda75k92uvhd74g30jsd1p26gbv4.apps.googleusercontent.com',
  support_phone : '9595389389',
  google_ads_conversion_id_label : 'AW-704132559/A5A7CMWfxMobEM_r4M8C',
  gallabox_client_id : 'd5f6da7b73a56d8e64bc6783ae3e1a1g',
};
